export default {
  methods: {
    async signInProvidAuthorizationCode (payload) {
      // NOTE this function signin
      const p = {
        ...{ authorization_code: '', redirect_url: '' },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/signin/providerid`,
        method: 'post',
        data: p
      }
      return await this.awaitAxios(options)
    },
    async getProviderIDCredential () {
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/signin/providerid/credential`,
        method: 'get'
      }
      return await this.awaitAxios(options)
    }

  }
}
